<template>
  <!-- <div class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100" id="sidenav-collapse-main"> -->
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="dashboard"
                          navText="Dashboard">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>
      <!-- Main Services -->
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="main-services" navText="Main Services">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">main-services</i>
          </template>
        </sidenav-collapse>
      </li>
      <!--Services -->
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="services" navText="Services">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">services</i>
          </template>
        </sidenav-collapse>
      </li>
      <!--Clinics -->
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="clinics" navText="Clinics">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">local_hospital</i>
          </template>
        </sidenav-collapse>
      </li>

      <!--Doctors -->
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="doctors" navText="Doctors">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">medical_services</i>
          </template>
        </sidenav-collapse>
      </li>

      <!--Appointments -->
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="appointments" navText="Appointments">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">Appointment</i>
          </template>
        </sidenav-collapse>
      </li>
      <!--Careers -->
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="careers" navText="Careers">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">Career</i>
          </template>
        </sidenav-collapse>
      </li>
      <!--Home Banners -->
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="home-banners" navText="Home Banners">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">image</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="contacts" navText="Contacts">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">contacts</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="degrees" navText="Degrees">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">degrees</i>
          </template>
        </sidenav-collapse>
      </li> -->

 
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="testimonials"
                          navText="Testimonials">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">testimonials</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="blogs" navText="Blogs">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">blogs</i>
          </template>
        </sidenav-collapse>
      </li>
      


    </ul>

  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavCollapse
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>
